import {
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  GET_COMPANY,
  INVITE_COMPANY,
  UPDATE_COMPANY,
  DELETE_COMPANY,
  GET_COMPANY_LIST_TO_SWITCH,
  RESET_COMPANY_ERROR,

  // Loading
  UPDATE_LOADING_STATE,
  IS_COMPANY_LOADING,
  IS_COMPANY_LIST_TO_SWITCH_LOADING,
  IS_COMPANY_UPDATE_LOADING,

  // Status
  UPDATE_STATUS_STATE,
  COMPANY_INVITE_STATUS,
  COMPANY_DELETE_STATUS,
} from "./actionType";

const INIT_STATE = {
  // company for main table
  company: [],
  isCompanyLoading: false,
  companyError: "",
  pageCount: 1,
  hasPreviousPage: false,
  hasNextPage: true,

  // company for switching, located in profile drop down
  companyListToSwitch: [],
  isCompanyListToSwitchLoading: false,
  companyListToSwitchError: "",
  companyListToSwitchPageCount: 1,
  companyListToSwitchHasPreviousPage: false,
  companyListToSwitchHasNextPage: true,

  companyInviteError: "",
  companyUpdateError: "",
  companyDeleteError: "",

  isCompanyUpdateLoading: false,

  companyInviteStatus: "idle", // or: 'loading', 'success', 'failed',
  companyDeleteStatus: "idle", // or: 'loading', 'success', 'failed'
};

const removeDuplicateCompany = (companys) => {
  return companys.filter((company, index) => {
    return index === companys.findIndex((comp) => company.id === comp.id);
  });
};

const Company = (state = INIT_STATE, action) => {
  switch (action.type) {
    // Common Success
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_COMPANY:
          return {
            ...state,
            company: action.payload.response.data,
            pageCount: action.payload.response.meta.pageCount,
            hasPreviousPage: action.payload.response.meta.hasPreviousPage,
            hasNextPage: action.payload.response.meta.hasNextPage,
          };
        case GET_COMPANY_LIST_TO_SWITCH:
          return {
            ...state,
            companyListToSwitch: removeDuplicateCompany([
              ...state.companyListToSwitch,
              ...action.payload.response.data,
            ]),
            companyListToSwitchPageCount:
              action.payload.response.meta.pageCount,
            companyListToSwitchHasPreviousPage:
              action.payload.response.meta.hasPreviousPage,
            companyListToSwitchHasNextPage:
              action.payload.response.meta.hasNextPage,
          };
        case UPDATE_COMPANY:
          return {
            ...state,
            company: state.company.map((company) =>
              company.id.toString() ===
              action.payload.response.data.tenantId.toString()
                ? {
                    ...company,
                    name: action.payload.response.data.tenantName,
                    // Update any other fields that came back from the API
                  }
                : company
            ),
          };
        default:
          return { ...state };
      }

    // Common Error
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_COMPANY:
          return {
            ...state,
            companyError: action.payload.error,
          };
        case GET_COMPANY_LIST_TO_SWITCH:
          return {
            ...state,
            companyListToSwitchError: action.payload.error,
          };
        case UPDATE_COMPANY:
          return {
            ...state,
            companyUpdateError: action.payload.error,
          };
        case DELETE_COMPANY:
          return {
            ...state,
            companyDeleteError: action.payload.error,
          };
        case INVITE_COMPANY:
          return {
            ...state,
            companyInviteError: action.payload.error,
          };
        default:
          return { ...state };
      }

    // Common Loading State
    case UPDATE_LOADING_STATE:
      switch (action.payload.actionType) {
        case IS_COMPANY_LOADING:
          return {
            ...state,
            isCompanyLoading: action.payload.isLoading,
          };
        case IS_COMPANY_LIST_TO_SWITCH_LOADING:
          return {
            ...state,
            isCompanyListToSwitchLoading: action.payload.isLoading,
          };
        case IS_COMPANY_UPDATE_LOADING:
          return {
            ...state,
            isCompanyUpdateLoading: action.payload.isLoading,
          };
        default:
          return { ...state };
      }

    // Common Status State
    case UPDATE_STATUS_STATE:
      switch (action.payload.actionType) {
        case COMPANY_INVITE_STATUS:
          return {
            ...state,
            companyInviteStatus: action.payload.status,
          };
        case COMPANY_DELETE_STATUS:
          return {
            ...state,
            companyDeleteStatus: action.payload.status,
          };
        default:
          return { ...state };
      }

    // Common Reset Error
    case RESET_COMPANY_ERROR:
      switch (action.payload.actionType) {
        case GET_COMPANY:
          return {
            ...state,
            companyError: "",
          };
        case GET_COMPANY_LIST_TO_SWITCH:
          return {
            ...state,
            companyListToSwitchError: "",
          };
        case UPDATE_COMPANY:
          return {
            ...state,
            companyUpdateError: "",
          };
        case DELETE_COMPANY:
          return {
            ...state,
            companyDeleteError: "",
          };
        case INVITE_COMPANY:
          return {
            ...state,
            companyInviteError: "",
          };
        default:
          return { ...state };
      }

    default:
      return { ...state };
  }
};

export default Company;
